import { Company, EditableCompanyDetails, RegistrationCompanyData, TelematicProviderTypeMetadata } from "types";
import { FormSource } from "./companyDetails";

export const COMPANY_CREATE_START = 'COMPANY_CREATE_START' as const;
export const COMPANY_CREATE_COMPLETED = 'COMPANY_CREATE_COMPLETED' as const;
export const COMPANY_CREATE_ERROR = 'COMPANY_CREATE_ERROR' as const;

export const COMPANY_REQUEST_START = 'COMPANY_REQUEST_START' as const;
export const COMPANY_REQUEST_COMPLETED = 'COMPANY_REQUEST_COMPLETED' as const;
export const COMPANY_REQUEST_ERROR = 'COMPANY_REQUEST_ERROR' as const;

export const COMPANY_UPDATE_START = 'COMPANY_UPDATE_START' as const;
export const COMPANY_UPDATE_COMPLETED = 'COMPANY_UPDATE_COMPLETED' as const;
export const COMPANY_UPDATE_ERROR = 'COMPANY_UPDATE_ERROR' as const;

export const REQUEST_TELEMATIC_ACCOUNT_TYPES_START = 'REQUEST_TELEMATIC_ACCOUNT_TYPES_START' as const;
export const REQUEST_TELEMATIC_ACCOUNT_TYPES_COMPLETED = 'REQUEST_TELEMATIC_ACCOUNT_TYPES_COMPLETED' as const;
export const REQUEST_TELEMATIC_ACCOUNT_TYPES_ERROR = 'REQUEST_TELEMATIC_ACCOUNT_TYPES_ERROR' as const;

export const COMPANY_REQUEST_FEATURE_PERMISSIONS = 'COMPANY_REQUEST_FEATURE_PERMISSIONS' as const;
export const COMPANY_REQUEST_FEATURE_PERMISSIONS_COMPLETED = 'COMPANY_REQUEST_FEATURE_PERMISSIONS_COMPLETED' as const;
export const COMPANY_REQUEST_FEATURE_PERMISSIONS_ERROR = 'COMPANY_REQUEST_FEATURE_PERMISSIONS_ERROR' as const;


export const createCompany = (company: RegistrationCompanyData) => {
    return {
        type: COMPANY_CREATE_START,
        payload: { company },
    };
};

export const createCompanyCompleted = (company: any) => {
    return {
        type: COMPANY_CREATE_COMPLETED,
        payload: { company },
    };
};

export const createCompanyError = (error: any) => {
    return {
        type: COMPANY_CREATE_ERROR,
        payload: {},
        error: error,
    };
};

//--------------------------------------------------------

export const getCompanyDetails = () => {
    return {
        type: COMPANY_REQUEST_START,
        payload: {},
    };
};

export const getCompanyDetailsCompleted = (company: Company) => {
    return {
        type: COMPANY_REQUEST_COMPLETED,
        payload: { company },
    };
};

export const getCompanyDetailsError = (error: any) => {
    return {
        type: COMPANY_REQUEST_ERROR,
        payload: {},
        error: error
    };
};

//-------------------------------------------------------

export const updateCompanyDetails = (companyDetails: EditableCompanyDetails, formSource: FormSource) => {
    return {
        type: COMPANY_UPDATE_START,
        payload: { companyDetails, formSource }
    };
};

export const updateCompanyDetailsCompleted = (companyDetails: EditableCompanyDetails, formSource: FormSource) => {
    return {
        type: COMPANY_UPDATE_COMPLETED,
        payload: { companyDetails, formSource }
    };
};

export const updateCompanyDetailsError = (error: any, formSource: FormSource) => {
    return {
        type: COMPANY_UPDATE_ERROR,
        error: error,
        payload: { formSource }
    };
};

//-------------------------------------------------------

export const getTelematicAccountTypes = () => ({
    type: REQUEST_TELEMATIC_ACCOUNT_TYPES_START,
    payload: {}
});

export const getTelematicAccountTypesCompleted = (telematicProviderTypeMetadata: TelematicProviderTypeMetadata[]) => ({
    type: REQUEST_TELEMATIC_ACCOUNT_TYPES_COMPLETED,
    payload: { telematicProviderTypeMetadata }
});

export const getTelematicAccountTypesError = (error: any) => ({
    type: REQUEST_TELEMATIC_ACCOUNT_TYPES_ERROR,
    payload: {},
    error
});

//-------------------------------------------------------

export const getCompanyFeaturePermissions = () => ({
    type: COMPANY_REQUEST_FEATURE_PERMISSIONS,
    payload: {}
});

export const getCompanyFeaturePermissionsCompleted = (featurePermissions: any) => ({
    type: COMPANY_REQUEST_FEATURE_PERMISSIONS_COMPLETED,
    payload: { featurePermissions }
});

export const getCompanyFeaturePermissionsError = (error: any) => ({
    type: COMPANY_REQUEST_FEATURE_PERMISSIONS_ERROR,
    payload: {},
    error
});

//-------------------------------------------------------

const Actions = {
    getCompanyDetails,
    getCompanyDetailsCompleted,
    getCompanyDetailsError,
    updateCompanyDetails,
    updateCompanyDetailsCompleted,
    updateCompanyDetailsError,
    createCompany,
    createCompanyCompleted,
    createCompanyError,
    getTelematicAccountTypes,
    getTelematicAccountTypesCompleted,
    getTelematicAccountTypesError,
    getCompanyFeaturePermissions,
    getCompanyFeaturePermissionsCompleted,
    getCompanyFeaturePermissionsError
};

export type CompanyAction = ReturnType<(typeof Actions)[keyof typeof Actions]>;